<script>
import axios from "axios";
import { getVariant } from "../../../helpers/badgeLookupTable";
import ModalFormDeleteAforo from "../../modals/ModalFormDeleteAforo.vue";
import ModalFormEditStatusAforo from "../../modals/ModalFormEditStatusAforo.vue";

export default {
  components: { ModalFormDeleteAforo, ModalFormEditStatusAforo },
  name: "Aforos",

  data() {
    return {
      despachoId: undefined,
      fetchIsPending: undefined,
      fetchIsSuccess: undefined,
      fetchIsError: undefined,

      aforoModal: {
        active: false,
        data: {},
      },
      fields: [
        { key: "codigo", label: "N° Despacho" },
        { key: "cliente", label: "Cliente" },
        { key: "aduana", label: "Aduana" },
        { key: "fecha_notificacion", label: "Fecha de notificación" },
        { key: "codigo_agente", label: "Código Agente" },
        { key: "tipo_inspeccion", label: "Tipo" },
        { key: "estado", label: "Estado" },
        { key: "acciones", label: "Acciones" },
      ],
      pageMeta: { current_page: 1 },
      selected: { id: undefined, base: { estado: undefined } },

      showDeleteModal: false,

      statusModal: false,
    };
  },
  created() {
    this.despachoId = this.$route.params.despachoId;
    this.fetch();
  },
  methods: {
    async fetch() {
      this.fetchIsPending = true;
      try {
        const query = {
          params: { ...this.filter },
        };

        const { data } = await axios.get(
          `/api/admin/aforos/despacho/${this.despachoId}`,
          query
        );

        if (data?.data && data?.meta) {
          this.aforos = [...data.data];
          this.pageMeta = { ...data.meta };
        }
      } catch (e) {
        console.error(e);
        this.fetchIsError = true;
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al obtener el listado de aforos en este despacho.",
        });
      }
      this.fetchIsError = false;
      this.fetchIsPending = false;
    },
    getVariant(status) {
      return getVariant(status);
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-4 mt-3">
    <div class="flex flex-row w-full">
      <button
        class="btn-principal ml-auto"
        @click="() => $router.push({ name: 'despacho-aforo-crear' })"
        :disabled="aforos?.length > 0"
      >
        Crear aforo
      </button>
    </div>
    <div v-if="!fetchIsPending">
      <b-table
        striped
        hover
        responsive
        show-empty
        :items="aforos"
        :fields="fields"
        :busy="fetchIsPending"
      >
        <template #empty>
          <h4 class="text-center">No hay Aforos disponibles</h4>
        </template>

        <template #cell(codigo)="row">
          <div class="flex flex-row text-sm items-center gap-2">
            <div
              class="h-6 w-[5px]"
              :class="[getVariant(row.item.estado)]"
            ></div>
            {{ row.item?.despacho?.despacho?.numero_despacho ?? "-" }}
          </div>
        </template>

        <template #cell(cliente)="row">
          {{ row.item.despacho?.despacho.cliente?.nombre ?? "-" }}
        </template>

        <template #cell(aduana)="row">
          {{ row.item.despacho?.despacho.aduana?.nombre ?? "-" }}
        </template>

        <template #cell(codigo_agente)="row">
          {{ row.item.despacho?.despacho.agente?.nombre ?? "-" }}
        </template>

        <template #cell(tipo_inspeccion)="row">
          {{ row.item.tipo_inspeccion?.nombre ?? "-" }}
        </template>

        <template #cell(estado)="row">
          <div
            class="flex flex-row items-center gap-2 text-white justify-center text-center px-2 py-1 cursor-pointer hover:brightness-110 hover:scale-105 transition-all"
            @click="
              () => {
                selected = row.item;
                statusModal = true;
              }
            "
            :class="[getVariant(row.item.estado)]"
          >
            {{ row.item?.estado ?? "-" }}
          </div>
        </template>

        <template #cell(created_at)="row">
          <p>
            {{ moment(row.item.created_at).format("DD-MM-YYYY HH:mm") }}
          </p>
        </template>
        <template #cell(acciones)="row">
          <div class="flex flex-col items-center gap-4 justify-center px-2">
            <div class="flex flex-row items-center gap-2">
              <button
                class="btn-extra-primario"
                @click="
                  () => {
                    selected = row.item;
                    showDeleteModal = true;
                  }
                "
              >
                <fas :icon="['fas', 'trash']"></fas>
                Eliminar
              </button>
              <button
                class="btn-extra-primario"
                @click="
                  () =>
                    $router.push({
                      name: 'despacho-aforo-editar',
                      params: {
                        despachoId: row.item.despacho_id,
                        aforoId: row.item.id,
                      },
                    })
                "
              >
                <fas :icon="['fas', 'pen']"></fas>
                Editar
              </button>
              <button
                class="btn-extra-primario"
                @click="
                  () =>
                    $router.push({
                      name: 'despacho-aforo-detalle',
                      params: {
                        despachoId: row.item.despacho_id,
                        aforoId: row.item.id,
                      },
                    })
                "
              >
                <fas :icon="['fas', 'eye']"></fas>
                Ver detalle
              </button>
            </div>
          </div>
        </template>

        <template #table-busy>
          <div class="text-center my-2" style="color: #ffce1e !important">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Cargando...</strong>
          </div>
        </template>
      </b-table>

      <b-pagination
        v-model="pageMeta.current_page"
        style="width: 100px; margin: auto"
        :total-rows="pageMeta.total"
        :per-page="pageMeta.per_page"
        align="fill"
        size="sm"
        class="my-0"
      />
    </div>
    <div v-else class="p-4">
      <b-spinner class="align-middle"></b-spinner>
      <strong> Cargando...</strong>
    </div>

    <modal-form-delete-aforo
      v-if="selected"
      :visible="showDeleteModal"
      :aforo="selected"
      @close-modal="() => (showDeleteModal = false)"
      @refetch="() => fetch()"
    />

    <modal-form-edit-status-aforo
      v-if="selected"
      :visible="statusModal"
      :aforo="selected"
      @close-modal="() => (statusModal = false)"
      @refetch="() => fetch()"
    />
  </div>
</template>
